import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ProformaExpenseService } from '../proforma-expense.service';
import { ProformaExpense } from '../proforma-expense';
import { ProformaExpenseComponent } from '../proforma-expense/proforma-expense.component';

@Component({
	selector: 'app-proforma-expense-list',
	templateUrl: './proforma-expense-list.component.html',
	styleUrls: ['./proforma-expense-list.component.css'],
	providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
	standalone: false,
	// make column heading sticky
	styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`]
})
export class ProformaExpenseListComponent implements OnInit, OnChanges {
	constructor(
		private proformaExpenseService: ProformaExpenseService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = proformaExpenseService.expenseFreqs
		//this.expenseFreqs = proformaExpenseService.expenseFreqs

		
	}
	// data
	@Input() proformaId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() isPublicAndPublish: boolean;
	@Input() updateExpense: boolean = false;

	proformaExpenses: any;
	proformaExpense: ProformaExpense;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	expenseFreqs: any;


	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'quantity', header: 'Quantity', width: 'auto' },
		{ field: 'expenseAmnt', header: 'Amount', width: 'auto' },
		{ field: 'expensePct', header: 'Percentage', width: 'auto' },
		{ field: 'expenseFreq', header: 'Frequency', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.proformaExpenseId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-proformaExpense-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			if(this.proformaId)
			{
				// show only proformaExpense that are assigned to this proformaId
				let proformaIdFilter = { 'proformaId': { 'value': this.proformaId, 'matchMode': 'in' } };
				Object.assign(event.filters, proformaIdFilter);
			}
			const pageNumber = Math.round(event.first / event.rows);
			this.proformaExpenseService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.proformaExpenses = res.data.proformaExpenses;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.proformaExpenses = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(proformaExpense: ProformaExpense) {
		try {
			this.formLoading = true;
			this.proformaExpenseService.update(proformaExpense)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.proformaExpenses.map((proformaExpense, i) => {
							if (proformaExpense.proformaExpenseId === res.data.proformaExpense.proformaExpenseId) {
								this.proformaExpenses[i] = res.data.proformaExpense;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(proformaExpense: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(proformaExpense));

			this.formLoading = true;
			this.proformaExpenseService.delete(proformaExpense.proformaExpenseId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.proformaExpenses.splice(this.proformaExpenses.indexOf(proformaExpense), 1);
						this.recordTotal = this.proformaExpenses.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Proforma Fees & Credits ' + proformaExpense.proformaExpenseId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Proforma Fees & Credits ' + proformaExpense.proformaExpenseId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Fees and Credits',
			proformaId: this.proformaId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaExpenseComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaExpenseCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(proformaExpense: ProformaExpense) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proformaExpense: proformaExpense,
			title: 'Edit Proforma Fees & Credits'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaExpenseComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateProformaExpenseCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteProformaExpenseCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addProformaExpenseCB(proformaExpense: ProformaExpense) {
		console.log('Adding ProformaExpense: ' + JSON.stringify(proformaExpense));
		// if we don't have a proformaExpenses array yet...
		if (!this.proformaExpenses) {
			this.proformaExpenses = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.proformaExpenses.unshift(proformaExpense);

		// no idea what this is but it is required to update the array
		this.proformaExpenses = [...this.proformaExpenses];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma Fees & Credits ' + proformaExpense.proformaExpenseId + ' Added', life: 3000 });
	}

	updateProformaExpenseCB(proformaExpense: ProformaExpense) {
		console.log('Updating ProformaExpense: ' + JSON.stringify(proformaExpense));
		let itemIndex = this.proformaExpenses.findIndex((item: any) => item.proformaExpenseId === proformaExpense.proformaExpenseId);
		this.proformaExpenses[itemIndex] = proformaExpense;

		// no idea what this is but it is required to update the array
		this.proformaExpenses = [...this.proformaExpenses];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma Fees & Credits ' + proformaExpense.proformaExpenseId + ' Updated', life: 3000 });
	}

	ngOnChanges() {
		this.ngOnInit();
	}

	deleteProformaExpenseCB(proformaExpense: ProformaExpense) {
		console.log('Removing ProformaExpense: ' + proformaExpense);
		this.proformaExpenses.splice(this.proformaExpenses.indexOf(proformaExpense), 1);
		this.recordTotal = this.proformaExpenses.length;

		// no idea what this is but it is required to update the array
		this.proformaExpenses = [...this.proformaExpenses];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma Fees & Credits ' + proformaExpense.proformaExpenseId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.proformaExpenses ? this.first === (this.proformaExpenses.length - this.rows) : true; }
	isFirstPage(): boolean { return this.proformaExpenses ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(proformaExpense: any) {
		if (proformaExpense?.expenseFreq) {
			const status = this.statuses.find((e: any) => e.value == proformaExpense.expenseFreq);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
